export abstract class ErrorToken {
}
